import AnalyticsConnector from 'analyticsConnector';
import { renderNetworkLogUi } from './networkCapture';
import {
  downloadNetworkLogs,
  getGANetworkLogs,
  getGVNetworkLogs,
} from './networkCapture/networkLogs';
import { iframeManager } from './networkCapture/iframeManager';
import { loadValidationPannel } from './validationManager';

let networkCaptureMode =
  localStorage.getItem('NETWORK_LOG_MODE') == 'true' ||
  localStorage.getItem('AUTO_ENABLE_NETWORK_LOG_MODE') == 'true';

window.AnalyticsConnector = AnalyticsConnector;

window.spnGodavariGv2AnalyticsInfo = {
  analyticsSDKVersion: GV2_ANALYTICS_SDK_VERSION,
  branch: GV2_BRANCH,
  commitHash: GV2_COMMITHASH,
  analyticsBuild: GV2_ANALYTICS_SDK_BUILD,
};

function init() {
  try {
    if (networkCaptureMode) {
      renderNetworkLogUi();
      window.getGVNetworkLogs = getGVNetworkLogs;
      window.getGANetworkLogs = getGANetworkLogs;
      window.downloadNetworkLogs = downloadNetworkLogs;
      iframeManager();
    }
    if (
      localStorage.getItem('NETWORK_PANEL_MODE') == 'true' ||
      window.VALIDATION_DASH_MODE
    ) {
      loadValidationPannel();
    }
  } catch (e) {
    console.info(e);
  }
}

if (document.body) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}
